<template>
  <div style="position: relative">
    <div v-if="isOpen" class="datepicker-foldout is-justify-content-center">
      <Datepicker
        v-model="date"
        range
        :minDate="new Date()"
        @update:modelValue="handleDate"
        :enableTimePicker="false"
        inline
        autoApply
        locale="nl"
      />
      <p class="pt-3">
        {{ $t("selectCheckinAndCheckOutDate") }}
      </p>
    </div>
    <div class="searchbar__icon">
      <i class="fas fa-calendar-day"></i>
    </div>
    <input
      placeholder="Datum"
      type="text"
      class="searchbar__input"
      name="dates"
      v-model="datePickerText"
      autocomplete="off"
      v-on:click="openFoldout()"
    />
  </div>
</template>
<script>
import Datepicker from "@vuepic/vue-datepicker";
//import "@vuepic/vue-datepicker/dist/main.css";

//https://vue3datepicker.com/api/props/#format
import { nl } from "date-fns/locale";
import moment from "moment";

export default {
  name: "DatepickerFoldout",
  props: {
    checkin: {
      type: [String, Date],
      default: null
    },
    nights: {
      type: [String, Number],
      default: null
    }
  },
  created: function () {
    this.locale = nl;
  },
  components: {
    Datepicker
  },
  emits: ["selectDates"],
  data() {
    return {
      date: null,
      today: new Date(),
      arrivalDate: this.checkin ? moment(this.checkin).toDate() : new Date(),
      departureDate:
        this.checkin && this.nights
          ? moment(this.checkin).add(this.nights, "days").toDate()
          : moment(new Date()).add(1, "days").toDate(),
      minDepartureDate: new Date(),
      isOpen: false,
      datePickerText: null
    };
  },
  mounted() {
    if (!this.checkin || !this.nights) {
      this.departureDate = moment(this.arrivalDate).add("1", "days").toDate();
    }
    this.setDatePickerText();
    this.emitDates();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      if (this.$el && !this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
    openFoldout() {
      this.isOpen = true;
    },
    closeFoldout() {
      this.isOpen = false;
    },
    selectArrival(arrivalDate) {
      let arrival = new Date(arrivalDate);
      this.arrivalDate = arrivalDate;
      this.minDepartureDate = moment(arrival).add("1", "days").toDate();

      if (moment(this.arrivalDate).isAfter(moment(this.departureDate))) {
        this.departureDate = moment(this.arrivalDate).add("1", "days").toDate();
      }
      this.setDatePickerText();
    },
    selectDeparture(departureDate) {
      let departure = new Date(departureDate);
      this.departureDate = departure;

      this.isOpen = false;
      this.setDatePickerText();
      this.emitDates();
    },
    handleDate(date) {
      const [startDate, endDate] = date;

      this.arrivalDate = startDate;
      this.departureDate = endDate;

      this.isOpen = false;
      this.setDatePickerText();
      this.emitDates();
    },
    format(date) {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `Selected date is ${day}/${month}/${year}`;
    },
    emitDates() {
      let nights = moment(this.departureDate).diff(
        moment(this.arrivalDate),
        "days"
      );
      if (nights == 0) nights = 1;

      let returnObj = {
        Checkin: moment(this.arrivalDate).format("YYYY-MM-DD"),
        Nights: nights
      };

      this.$emit("selectDates", returnObj);
    },
    setDatePickerText() {
      let formattedArrival = moment(this.arrivalDate).format("DD-MM-YYYY");
      let formattedDeparture = moment(this.departureDate).format("DD-MM-YYYY");

      this.datePickerText = formattedArrival + "  -  " + formattedDeparture;
    },
    updateDatesFromProps() {
      if (this.checkin) {
        this.arrivalDate = moment(this.checkin).toDate();
        if (this.nights) {
          this.departureDate = moment(this.checkin)
            .add(this.nights, "days")
            .toDate();
        }
        const selectedDate = [this.arrivalDate, this.departureDate];
        this.date = selectedDate;
        this.setDatePickerText();
      }
    }
  },
  watch: {
    checkin: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.updateDatesFromProps();
        }
      }
    },
    nights(newValue) {
      if (this.checkin && newValue) {
        this.updateDatesFromProps();
      }
    }
  }
};
</script>
